import { IItem } from "../Model/Storage/IItem";
import { joinNonEmpty } from "./String";

type Nullable<T> = T | null | undefined;
export type ObjectWalkerCondition<T> = (item?: T) => boolean;
export type ObjectWalkerCallback<T> = (item?: T) => Nullable<T>;

export function walk<TInput extends IItem>(
  item: TInput,
  path: string,
  condition: ObjectWalkerCondition<IItem>,
  callback: ObjectWalkerCallback<IItem>
): TInput {
  if (item == null || callback == null) {
    return item;
  }

  const conditionFn = condition ?? defaultCondition;

  let currentItem = { ...item };
  if (conditionFn(currentItem)) {
    const result = callback(currentItem) as TInput;
    if (result != null) {
      currentItem = { ...result };
    }
  }

  const [currentPathElement, ...rest] = path.split(`.`);
  let subItem = currentItem[currentPathElement];
  if (subItem == null) {
    return currentItem;
  }

  const remainingPath = joinNonEmpty(rest, `.`);
  if (Array.isArray(subItem)) {
    subItem = subItem.map((entry: IItem) => walk<IItem>(entry, remainingPath, condition, callback));
  } else {
    subItem = walk<IItem>(subItem as IItem, remainingPath, condition, callback);
  }

  return { ...currentItem, [currentPathElement]: subItem };
}

function defaultCondition(): boolean {
  return true;
}
